import { render, staticRenderFns } from "./RSpinnerOverlay.vue?vue&type=template&id=1a6f82e8&"
import script from "./RSpinnerOverlay.vue?vue&type=script&lang=js&"
export * from "./RSpinnerOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports